import { Theme } from "@remo-co/ui-core/src/types";
import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

interface Props {
  isIsometric?: boolean;
}

export const useStyles = makeStyles<Theme, Props>((theme) => ({
  hostOnboardingDummy: {
    display: "none",
  },
  // These three properties (mapRoom, edit, and adminSeat) need to be in this file to use
  // nested selectors.
  mapRoom: {
    position: "absolute",
    background: "rgba(255, 255, 255, 0)",
    pointerEvents: "none",

    "&:hover": {
      "& $lockTableMovementButton": {
        opacity: 0.8,
      },
      "& $edit": {
        opacity: 1,
      },
      "& $adminSeat": {
        opacity: 1,
      },
    },
  },
  lockTableMovementButton: ({ isIsometric }) => {
    const position = isIsometric
      ? { bottom: "50%", right: "-15px" }
      : { top: 0, right: 0 };

    return {
      cursor: "pointer",
      borderRadius: "100px",
      pointerEvents: "all",
      opacity: 0,
      transition: ".2s opacity",
      position: "absolute",
      background: theme.palette.events.blueSecondary,
      ...position,
    };
  },
  adminSeat: {
    opacity: 0,
    transition: "opacity 200ms ease-out 200ms",
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    padding: 0,
  },
  adminSeatContainer: {
    position: "absolute",
  },
  edit: {
    opacity: 0,
    "&:hover": {
      opacity: 1,
    },
  },
  overflowAvatar: {
    borderRadius: "20px",
    height: "40px",
    width: "40px",
  },
}));
